import { Component, type ReactNode } from 'react'

type State = { error: Error | null }

/** Last line of defence: a broken screen shows a message instead of a blank page. */
export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  render() {
    if (!this.state.error) return this.props.children
    return (
      <div className="g3 fatal" role="alert">
        <div className="window iron wood fatal__win">
          <h2 className="window__title">Что-то сломалось</h2>
          <p>Экран не смог отрисоваться. Перезагрузите страницу; если повторится — напишите нам.</p>
          <button type="button" className="plank plank--gold" onClick={() => window.location.reload()}><span className="plank__in">Перезагрузить</span></button>
        </div>
      </div>
    )
  }
}
